
    /**
     * Adds an item to the Shopify cart asynchronously using the AJAX API.
     * Dynamic payload architecture safely handles standard items and Recharge subscriptions.
     */
    function addQuickEntry(el) {
        // Pull tracking identifiers from the HTML data-attributes
        const variantId = el.getAttribute('data-variant-id');
        const sellingPlanId = el.getAttribute('data-selling-plan');

        // Validation guard: Shopify strictly requires a Variant ID to locate inventory
        if (!variantId) {
            alert('Missing product variant. Please try again.');
            return;
        }

        // UX State: Add a loading class to handle button styling or spin animations during execution
        el.classList.add('loading');

        // Construct standard required configuration object for Shopify's AJAX endpoint
        const formData = {
            id: variantId,
            quantity: 1
        };

        // Subscription Guard: Inject selling_plan configuration safely only if it's not a placeholder
        const isPlaceholder = !sellingPlanId || sellingPlanId.includes('YOUR_');
        if (!isPlaceholder) {
            formData.selling_plan = sellingPlanId;
        }

        // Fire request to the native Shopify Cart asynchronous processing engine
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(res => {
                if (!res.ok) throw new Error('Shopify API rejection');
                return res.json();
            })
            .then(data => {
                // Success Cycle: Force interface components to synchronize with current data
                updateCartDrawer(); 
                openCartDrawer();
            })
            .catch(err => {
                console.error('Failed to add product to cart:', err);
                alert('Something went wrong. Try again.');
            })
            .finally(() => {
                // Visual Cleanup: Tear down the interface loading states completely
                el.classList.remove('loading');
            });
        }

    /**
     * Refreshes global quantities and pulls asynchronous DOM updates for mini-cart elements.
     */
    function updateCartDrawer() {
        // Query server for updated data array mapping current lines and pricing totals
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Update text configurations across target layout locations (like header badge counters)
                const thbCountEl = document.querySelector('.thb-item-count');
                if (thbCountEl) {
                    thbCountEl.textContent = cart.item_count;
                }

                // UI Redraw Strategy 1: Check if the custom theme explicitly exposes an internal hook
                if (Shopify?.theme?.cart?.refresh) {
                    Shopify.theme.cart.refresh();
                } else {
                    // UI Redraw Strategy 2 (Fallback): Asynchronously extract server-side layout and slide it into place
                    const cartDrawer = document.querySelector('.cart-drawer');
                    if (cartDrawer) {
                        fetch('/cart')
                            .then(res => res.text())
                            .then(html => {
                                const doc = new DOMParser().parseFromString(html, 'text/html');
                                const newCart = doc.querySelector('.cart-drawer');
                                if (newCart) cartDrawer.innerHTML = newCart.innerHTML;
                            });
                    }
                }
            });
    }

    /**
     * Locates the default hidden element trigger used by the underlying theme engine to pull open the drawer.
     */
    function openCartDrawer() {
        const trigger = document.querySelector('#cart-drawer-toggle');
        if (trigger) trigger.click();
    }